<template>
  <div>
    <top-bar v-if="mainScrollCont" />
    <div ref="mainContainer" class="container--scrollable">
      <slot />
    </div>
    <main-navigation :menu-items="mainMenu" />
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import TopBar from '@/views/components/TopBar.vue'
import MainNavigation from '@/views/components/MainNavigation.vue'

export default {
  components: {
    TopBar,
    MainNavigation
  },
  data () {
    return {}
  },
  computed: {
    mainScrollCont: get('Interface/mainScrollCont'),
    mainMenu: get('Settings/mainMenu')
  },
  methods: {
    setMainScrollCont: call('Interface/setMainScrollCont')
  },
  mounted: function () {
    this.setMainScrollCont(this.$refs.mainContainer)
  }
}
</script>

<style lang="scss"></style>
